<template>
  <div class="home">
    <Gsap company="HLUTUR AS" title="Konsulent tjenester | Program utvikling " />
  </div>
</template>

<script>
import Gsap from "@/components/Gsap.vue";

export default {
  name: "GsapView",
  components: {
    Gsap
  }
};
</script>
